import React, { useState } from "react";
import { FaQuoteLeft, FaChevronLeft, FaChevronRight } from "react-icons/fa";

const TESTIMONIALS = [
    {
        id: 1,
        text: "We used to rely on too many WhatsApp messages and spreadsheets. This just keeps everything in one place. You can quickly see what's been done and what still needs sorting.",
        name: "Fredrick Ochieng",
        location: "Dallas, Texas",
        avatar: "https://i.pravatar.cc/150?u=fredrick",
    },
    {
        id: 2,
        text: "Mwanzilazuri kati ya site na ofisi yamekuwa rahisi sana. Tumeweza maliza moja kwa moja, hakuna kupoteza faili. Kazi inaeenda haraka na delays zimepungua.",
        name: "Abdul Rashid",
        location: "Dar es Salaam, Tanzania",
        avatar: "https://i.pravatar.cc/150?u=abdul",
    },
    {
        id: 3,
        text: "Earlier we struggled to keep track of site progress across multiple projects. ConRa brings everything into one place. Our team now stays updated and delays have reduced significantly.",
        name: "Ruth Nzoki",
        location: "Nairobi, Kenya",
        avatar: "https://i.pravatar.cc/150?u=ruth",
    },
    {
        id: 4,
        text: "From initial setup to go-live, ConRa's team supported us every step of the way. Their responsiveness and attention to our unique workflows meant we didn't have to compromise.",
        name: "Michael Wafula",
        location: "Kampala, Uganda",
        avatar: "https://i.pravatar.cc/150?u=michael",
    },
    {
        id: 5,
        text: "ConRa has completely changed how we manage communication between field teams and designers. The centralized dashboard keeps everyone aligned — no more lost WhatsApp updates.",
        name: "James Kariuki",
        location: "Mombasa, Kenya",
        avatar: "https://i.pravatar.cc/150?u=james",
    },
    {
        id: 6,
        text: "As a project owner, I appreciate how ConRa gives me clear visibility into progress without having to call the site daily. The analytics are straightforward and help me decide faster.",
        name: "Sarah Odhiambo",
        location: "Nairobi, Kenya",
        avatar: "https://i.pravatar.cc/150?u=sarah",
    },
];

const CARDS_PER_PAGE = 3;
const TOTAL_PAGES = Math.ceil(TESTIMONIALS.length / CARDS_PER_PAGE);

const PricingTestimonials = () => {
    const [page, setPage] = useState(0);

    const visible = TESTIMONIALS.slice(
        page * CARDS_PER_PAGE,
        page * CARDS_PER_PAGE + CARDS_PER_PAGE
    );

    return (
        <div className="ptesti-wrapper">
            <div className="ptesti-cards">
                {visible.map((t) => (
                    <div key={t.id} className="ptesti-card">
                        <FaQuoteLeft className="ptesti-quote-icon" />
                        <p className="ptesti-text">{t.text}</p>
                        <div className="ptesti-author">
                            <img src={t.avatar} alt={t.name} className="ptesti-avatar" />
                            <div className="ptesti-author-info">
                                <span className="ptesti-name">{t.name}</span>
                                <span className="ptesti-location">{t.location}</span>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Prev / Next navigation */}
            <div className="ptesti-nav">
                <button
                    className="ptesti-nav-btn"
                    onClick={() => setPage((p) => Math.max(p - 1, 0))}
                    disabled={page === 0}
                    aria-label="Previous"
                >
                    <FaChevronLeft />
                </button>
                <button
                    className="ptesti-nav-btn"
                    onClick={() => setPage((p) => Math.min(p + 1, TOTAL_PAGES - 1))}
                    disabled={page === TOTAL_PAGES - 1}
                    aria-label="Next"
                >
                    <FaChevronRight />
                </button>
            </div>
        </div>
    );
};

export default PricingTestimonials;
